import * as React from 'react';
import { BaSeInput, BaSeCheckbox, BaSeTag } from '@base/react';
import { LabelTitle } from '../components/LabelTitle';

const LOADING_STATES = {
  FETCHING_TAGS: 4,
};

export const TagsAndThemesSection = ({
  formData,
  availableOptions,
  uiState,
  onFieldChange,
  onToggleCheckbox,
  onAddTag,
  onDeleteTag,
}) => {
  return (
    <>
      <div>
        <LabelTitle
          label="Tema"
          subTitle="Insira os temas vinculados à solução. Comece a digitar e selecione da lista."
          isItalic
        />
        <div
          style={{
            display: 'flex',
            flexFlow: 'column',
            gap: 6,
            padding: '2px 0',
          }}
        >
          {availableOptions.temas?.map((item) => (
            <BaSeCheckbox
              key={item.id}
              align="top-left"
              color="default"
              label={item.nome}
              checked={item.id in (formData.temasSelecionadas ?? {})}
              onChange={() => onToggleCheckbox(item.id, 'temasSelecionadas')}
              size="medium"
            />
          ))}
        </div>
      </div>
      <div>
        <LabelTitle label="Tags" />
        <BaSeInput
          isLoading={uiState.loading === LOADING_STATES.FETCHING_TAGS}
          onChange={(value) => onFieldChange('tagInput', value)}
          value={formData.tagInput}
          onSpecificKeyDown={[{ enter: () => onAddTag() }]}
          iconButton={{
            action: () => onAddTag(),
            name: 'plus',
            type: 'primary',
            typeButton: 'base-button',
            value: 'Adicionar',
          }}
        />
        <div
          style={{
            display: 'flex',
            gap: 4,
            flexWrap: 'wrap',
            paddingTop: 8,
          }}
        >
          {!!formData.tags?.length &&
            formData.tags?.sort()?.map((tag, index) => (
              <div key={index}>
                <BaSeTag
                  color="default"
                  label={tag}
                  type="primary"
                  onClose={() => onDeleteTag(tag)}
                />
              </div>
            ))}
        </div>
      </div>
    </>
  );
};
